activateSocialButtons();
activateMobileMenu();

// Mobile menu
function activateMobileMenu () {
  var container = document.getElementById('container');
  var toggle = document.getElementById('mobile-nav-toggle');
  var close = document.getElementById('mobile-nav-close');
  var navWrapper = document.getElementById('mobile-nav-wrapper');
  var nav = document.getElementById('mobile-nav');

  var settings = {
    menuOpen: false
  }

  navWrapper.onclick = function (e) {
    e.stopPropagation();
  }

  toggle.onclick = function (e) {
    e.stopPropagation();
    if (settings.menuOpen) {
      nav.classList.remove('visible');
      container.onclick = function () {
        return false;
      }
      settings.menuOpen = false;
    } else {
      nav.classList.add('visible');
      container.onclick = function () {
        if (settings.menuOpen) {
          nav.classList.remove('visible');
          settings.menuOpen = false;
        }
      }
      settings.menuOpen = true;
    }
  }

  close.onclick = function () {
    if (settings.menuOpen) {
      nav.classList.remove('visible');
      container.onclick = function () {
        return false;
      }
      settings.menuOpen = false;
    }
  }
}

// Social buttons
function activateSocialButtons () {
  var url = window.location.href;
  var title = document.title;
  var metaTags = document.getElementsByTagName("meta");
  var description = metaTags.description.getAttribute('content') || 'Спецпроект ООО "РДВ-Медиа" Тайны Большого театра';

  // console.log(description);

  var facebook = document.getElementById('share-facebook');
  var vk = document.getElementById('share-vk');
  var twitter = document.getElementById('share-twitter');
  var like = document.getElementById('share-like');

  facebook.href = 'https://www.facebook.com/sharer/sharer.php?u=' + url;
  vk.href = 'https://vk.com/share.php?title=' + title + '&description=' + description + '&url=' + url;
  twitter.href = 'https://twitter.com/share?text=' + title + '&url=' + url;
  like.setAttribute('data-href', url);
}
